import { render } from "./TariffBandComponent.vue?vue&type=template&id=3021915a&scoped=true"
import script from "./TariffBandComponent.vue?vue&type=script&lang=js"
export * from "./TariffBandComponent.vue?vue&type=script&lang=js"

import "./TariffBandComponent.vue?vue&type=style&index=0&id=3021915a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3021915a"]])

export default __exports__